import { createContext, useContext } from 'react';

type SqToastContextValue = {
  showCopiedToast: (label: string) => void;
  showToast: (text: string) => void;
};

export const SqToastContext = createContext<SqToastContextValue>({
  showCopiedToast: () => {},
  showToast: () => {},
});

export const useSqToast = () => useContext(SqToastContext);
